
import log from "plugins/loglevel"
import $ from "jquery"
import "chosen-jquery"
import chosen_init from "plugins/chosen"
import {
  onClickOutside,
} from "plugins/vanilla-clickout"
import isBlankStr from "underscore.string/isBlank"

import {
  default as fa_angle_factory,
  FontAwesomeAngle,
} from "components/icons/fa_angle"
import {
  MinMaxSelect,
  Selector as BaseSelector,
  InputSelector as BaseInputSelector,
  DEFAULT_SELECTOR as BASE_DEFAULT_SELECTOR,
} from "./base"


export type Selector = BaseSelector & {
  scope:    string | Element | JQuery
  main:     string | Element | JQuery
  toggle:   string | Element | JQuery
  dropdown: string | Element | JQuery
  angle:    string | Element | JQuery

  min_wrapper:  string | Element | JQuery
  min_select:   string | Element | JQuery

  max_wrapper:  string | Element | JQuery
  max_select:   string | Element | JQuery

  selected_text:  string | Element | JQuery
  chosen_menu:    string | Element | JQuery
}
export type InputSelector = BaseInputSelector & {
  scope?:    string | Element | JQuery
  main?:     string | Element | JQuery
  toggle?:   string | Element | JQuery
  dropdown?: string | Element | JQuery
  angle?:    string | Element | JQuery

  min_wrapper?:  string | Element | JQuery
  min_select?:   string | Element | JQuery

  max_wrapper?:  string | Element | JQuery
  max_select?:   string | Element | JQuery

  selected_text?:  string | Element | JQuery
  chosen_menu?:    string | Element | JQuery
}
const DEFAULT_SELECTOR = Object.assign({}, BASE_DEFAULT_SELECTOR, {
  scope:    ".cell-listing-filter",
  main:     ".cell-listing-filter__area-size-dropdown-container",
  toggle:   ".dropdown-with-input-toggle",
  dropdown: ".dropdown-menu-with-input",
  angle:    ".btn-filter i",

  min_wrapper:  ".filter-option--gross-min",
  min_select:   ".cell-listing-filter__minimum-area-size-input", // .filter-option-min

  max_wrapper:  ".filter-option--gross-max",
  max_select:   ".cell-listing-filter__maximum-area-size-input", // .filter-option-max

  selected_text:  ".filter-option-selected",
  chosen_menu:    ".chosen-results",
})


class MinMaxSelectWithChosen extends MinMaxSelect {
  protected selector: Selector

  protected $max_wrapper: JQuery
  protected $min_wrapper: JQuery

  protected $toggle: JQuery
  protected $dropdown: JQuery

  protected $angle: JQuery
  protected fa_angle: FontAwesomeAngle

  protected $selected_text: JQuery

  constructor(selector?: InputSelector){
    const merged_selector = Object.assign({}, DEFAULT_SELECTOR, selector)
    super(merged_selector, {run_post_initialization: false})

    this.selector = merged_selector
    this.$scope = $(this.selector.scope)
    this.$el = this.$scope.find(this.selector.main)

    this.selector = Object.assign({}, DEFAULT_SELECTOR, selector)
    this.$scope = $(this.selector.scope)
    this.$el = this.$scope.find(this.selector.main)

    this.$min_select = this.$el.find(this.selector.min_select)
    this.$max_select = this.$el.find(this.selector.max_select)
    chosen_init(this.$min_select, {
      inherit_select_classes: this.$min_select.data("inherit-select-classes"),
    })
    chosen_init(this.$max_select, {
      inherit_select_classes: this.$max_select.data("inherit-select-classes"),
    })

    this.$max_wrapper = this.$el.find(this.selector.max_wrapper)
    this.$max_wrapper.find("input").attr("placeholder", this.$max_select.data("placeholder"))
    this.$min_select.trigger("chosen:open")

    this.$min_wrapper = this.$el.find(this.selector.min_wrapper)
    this.$min_wrapper.find("input").attr("placeholder", this.$min_select.data("placeholder"))

    this.$toggle = this.$el.find(this.selector.toggle)
    this.$dropdown = this.$el.find(this.selector.dropdown)

    this.$angle = this.$el.find(this.selector.angle)
    this.fa_angle = fa_angle_factory.create(this.$angle)

    this.$selected_text = this.$el.find(this.selector.selected_text)

    this.setData()
    this.updateText(this.convertValueToLabel())
    this.updateMinChosenPlaceHolder()
    this.updateMaxChosenPlaceHolder()

    if (this.$el.length === 0){
      log.error(`scope: ${this.selector.scope}, main: ${this.selector.main}`)
      throw new Error("DropdownContainer init with null element")
    }

    this.bind_action()
  }

  public close(){
    this.hideDropdown()
    this.fa_angle.close()
    return this
  }
  public open(){
    this.showDropdown()
    this.fa_angle.open()
    return this
  }
  protected showDropdown(): void {
    this.$dropdown.show()
  }
  protected hideDropdown(): void {
    this.$dropdown.hide()
  }
  public toggle(){
    if (this.$dropdown.is(":visible")){
      this.close()
    }
    else{
      this.open()
    }
    return this
  }
  public reset(){
    super.reset()

    this.$min_select.trigger("chosen:updated")
    this.$max_select.trigger("chosen:updated")
    this.updateText(this.convertValueToLabel())
    this.updateMinChosenPlaceHolder()
    this.updateMaxChosenPlaceHolder()
    this.close()
  }

  protected bind_action(): void {
    super.bind_action()

    this.$toggle.on("click", () => {
      this.onClick()
    })

    onClickOutside(this.$el[0] as HTMLElement, (e) => {
      this.onClickout(e)
    })

    this.$max_wrapper.find("input").on("focusin", () => {
      this.onMaxInputFocus()
    })
    this.$min_wrapper.find("input").on("focusin", () => {
      this.onMinInputFocus()
    })
  }
  protected onClick(): void{
    // === Fix for first selection after page load === #
    // When not activated, the first selection by cursor after page load will be incorrect

    this.toggle()

    setTimeout(() => {
      // set Timeout here
      // hypothesis: As button is not a part of the chosen jquery
      // so we handle onClick event here
      // but later chosen treat this as an clickout event of chosen
      // click our btn -> clickout of chosen -> hiding
      // so we Have to use settimeout to activate the chosen afterward
      // click our btn (onclick handle)-> clickout of chosen -> hiding -> chosen:open
      //                    |------------------------------------------------^
      this.$min_select.trigger("chosen:open")
    })
  }
  protected onClickout(_e: Event){
    this.$dropdown.hide()
    this.fa_angle.close()
  }
  protected onChange(e: Event){
    super.onChange(e)

    const target = e.target
    this.updateText(this.convertValueToLabel())
    if (this.$min_select.is(target)){
      this.updateMinChosenPlaceHolder()
    }
    if (this.$max_select.is(target)){
      this.updateMaxChosenPlaceHolder()
    }
    this.close()
  }
  protected onMaxInputFocus(){
    this.$min_wrapper.find(this.selector.chosen_menu).hide()
    this.$max_wrapper.find(this.selector.chosen_menu).show()
  }
  protected onMinInputFocus(){
    this.$max_wrapper.find(this.selector.chosen_menu).hide()
    this.$min_wrapper.find(this.selector.chosen_menu).show()
  }
  protected updateMinGtMax(){
    super.updateMinGtMax()

    this.$max_select.trigger("chosen:updated")
    this.updateMaxChosenPlaceHolder()
  }
  protected renewMaxOptions(){
    super.renewMaxOptions()

    this.$max_select.trigger("chosen:updated")
  }
  protected setData(){
    if (typeof this.$selected_text.data("original-text") === "undefined"){
      this.$selected_text.data("original-text", this.$selected_text.text())
    }
  }
  protected updateMinChosenPlaceHolder(){
    const min_selected_el = this.$min_select.find("option:selected")
    if ( !isNaN( parseInt(min_selected_el.val(), 10) ) ){
      this.$min_wrapper.find("input").attr("placeholder", min_selected_el.text())
    }
    else{
      this.$min_wrapper.find("input").attr("placeholder", this.$min_select.data("placeholder"))
    }
  }
  protected updateMaxChosenPlaceHolder(){
    const max_selected_el = this.$max_select.find("option:selected")
    if ( !isNaN( parseInt(max_selected_el.val(), 10) ) ){
      this.$max_wrapper.find("input").attr("placeholder", max_selected_el.text())
    }
    else{
      this.$max_wrapper.find("input").attr("placeholder", this.$max_select.data("placeholder"))
    }
  }
  protected convertValueToLabel(){
    const min_value = this.$min_select.val()
    const max_value = this.$max_select.val()

    if (!isBlankStr(min_value) && !isBlankStr(max_value)){
      return `${min_value} - ${max_value}`
    }

    if (!isBlankStr(min_value)){
      return `> ${min_value}`
    }

    if ( !isBlankStr(max_value) ){
      return `< ${max_value}`
    }

    return this.$selected_text.data("original-text")
  }
  protected updateText(label: string){
    const original_text = this.$selected_text.data("original-text")
    this.$selected_text.toggleClass("nonempty", label !== original_text)
    this.$selected_text.text(label)
  }
}


export {
  MinMaxSelectWithChosen,
  DEFAULT_SELECTOR,
}
